var _style, _path, _defs, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogfilesDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Rahmen",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 106",
    style: {
      enableBackground: "new 0 0 110 106"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B4CCDD;}\r\n\t.st1{clip-path:url(#SVGID_2_);fill:#B4CCDD;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35,21v44h40V21H35z M73,63H37V23h36V63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 41.2,
    y: 28,
    width: 27.6,
    height: 30
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.2,31.4c-0.3-0.5-0.7-1-1.3-1.3c-0.9-0.7-1.9-1-2-1l-1.4-0.3c-0.2,0.3-0.4,0.6-0.4,1.1 c0,1.8,0.6,2.2,0.6,2.2h4.8C46.5,31.8,46.4,31.6,46.2,31.4L46.2,31.4z M46.2,31.4"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.7,54.7c0,1.1-0.4,1.9-0.9,2.5C47.3,57.7,46,58,46,58l19.8,0h0.5c0,0,0,0,0.1,0c0.6,0,1.2-0.3,1.7-1 c0.4-0.6,0.7-1.4,0.7-2.3H48.7z M48.7,54.7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68,33.5c0-4.9-4.6-5.5-4.6-5.5H43.3c0,0,3.6,0.9,4.4,4.1c0.1,0.4,0.2,0.9,0.2,1.4c0,6.1-4.6,13.7-4.6,19 c0,0.7,0.1,1.4,0.3,2c0.2,0.5,0.4,1,0.7,1.4c0.2,0.2,0.4,0.5,0.7,0.6c0.3,0.2,0.5,0.3,0.9,0.3c0.4,0,0.8-0.2,1.1-0.5 c0.4-0.4,0.6-1,0.6-1.7v-1.1h15.9c-0.1-0.3-0.1-0.7-0.1-1.1C63.4,47.1,68,39.5,68,33.5z M52.6,48.4h-3.9v-3.9l9.2-9.2l3.9,3.9 L52.6,48.4z M58.7,34.5l1.3-1.3c0.5-0.5,1.3-0.5,1.9,0l2.1,2.1c0.5,0.5,0.5,1.3,0,1.9l-1.3,1.3L58.7,34.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogfilesDefault);
export default __webpack_public_path__ + "static/media/logfiles-default.9faf5d90ebab9e88ddbb6c7da9bd27f6.svg";
export { ForwardRef as ReactComponent };